// extracted by mini-css-extract-plugin
export default {"content":"Todo_content__3iW5u","heading":"Todo_heading__8QABL","advice":"Todo_advice__W4dJp","circle":"Todo_circle__RRw-4"};